import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Modal } from '@figure/frontlib-gui';
import { useLeaveSurvey, useLeaveSurveyModal } from 'shared/hooks';
import { LeaveSurveyForm } from '../components';

const LeaveSurveyContainer = () => {
  const params = useParams();
  const { uuid } = params;
  const { leaveReasons, handleSubmit } = useLeaveSurvey(uuid);
  const { surveyOpen, surveyTriggered, surveyShowDisabled, openSurvey, closeSurvey } = useLeaveSurveyModal();

  const handleUnload = (e) => {
    if (!surveyTriggered && !surveyShowDisabled) {
      window.setTimeout(openSurvey, 100);

      e.preventDefault();

      // this doesn't work anymore in newer browsers
      // will get the standard browser message.
      e.returnValue = 'We’re sorry to see you go. Please cancel to complete a short survey.';
      return e.returnValue;
    }
    return undefined; // no popup
  };

  useEffect(() => {
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  });

  return (
    <Modal size="md" isOpen={surveyOpen} onClose={closeSurvey}>
      <LeaveSurveyForm
        handleSubmit={async (data) => {
          try {
            await handleSubmit(data);
          } finally {
            closeSurvey();
          }
        }}
        leaveReasons={leaveReasons}
      />
    </Modal>
  );
};

// LeaveSurveyContainer.propTypes = {
// };

export default LeaveSurveyContainer;
